const POPUP_SHOWN_KEY_PREFIX = 'smsr-kalama-teaser-popup-shown'
const STORED_TRUE = 'true'

export function isKalamaTeaserPopupShownInTab(accountId: string): boolean {
  try {
    return sessionStorage.getItem(`${POPUP_SHOWN_KEY_PREFIX}:${accountId}`) === STORED_TRUE
  } catch {
    return false
  }
}

export function markKalamaTeaserPopupShownInTab(accountId: string): void {
  try {
    sessionStorage.setItem(`${POPUP_SHOWN_KEY_PREFIX}:${accountId}`, STORED_TRUE)
  } catch {
    // Private-mode and quota errors are non-fatal.
  }
}
